module.exports = __webpack_public_path__ + "img/kommune-623.970217ae.svg";